<template>
  <b-card
    class="mb-2 pricing-details-widget remove-shadow"
    :class="showBanner ? '' : 'd-none'"
  >
    <div class="d-flex mb-3">
      <img src="@/assets/images/common/info-icon.svg" alt="Info Icon" />
      <h4 class="heading font-weight-bold ml-3 my-1">
        {{ $t('dashboard.pricingDetails.title') }}
        {{ account.pricing_changed_time | moment('D MMMM YYYY.') }}
      </h4>
      <b-icon-x
        class="close-icon ml-auto"
        font-scale="1"
        @click="dismissBanner"
      />
    </div>
    <div>
      <div
        v-track-click
        @click="$refs.pricingModal.show()"
        id="pricing-banner-clicked"
        class="pricing-banner-link"
      >
        {{ $t('dashboard.pricingDetails.link') }}
        <b-icon-chevron-right class="cross-icon ml-2" />
      </div>
    </div>
    <b-modal ref="pricingModal" hide-footer centered>
      <template #modal-title
        ><span class="title-modal">{{
          $t('dashboard.pricingDetails.modalTitle')
        }}</span></template
      >
      <table class="table invoice-info-table">
        <tr>
          <th>
            {{ $t('account.index.pricing.fields.advanceRate') }}
          </th>
          <td class="text-right font-weight-bold small-text">
            <strong>{{ account.plan.advance_rate | percentSign }}</strong>
            {{ $t('account.index.pricing.fields.ofNetInvoiceValue') }}
          </td>
        </tr>
        <tr>
          <th>
            {{ $t('account.index.pricing.fields.factoringComission') }}
          </th>
          <td class="text-right small-text">
            <div
              class="mb-3"
              v-for="factoringComission in account.plan.factoring_commission"
              :key="factoringComission.days"
            >
              <strong
                >{{ $t('account.index.pricing.fields.upto') }}
                {{ factoringComission.days }}
                {{ $t('account.index.pricing.fields.days') }}</strong
              >
              <br />
              <span class="font-weight-bold small-text">
                {{ factoringComission.rate | percentSign }}
                {{ $t('account.index.pricing.fields.ofNetInvoiceValue') }}</span
              >
            </div>
          </td>
        </tr>
        <tr v-if="isMx">
          <th>
            {{ $t('account.index.pricing.fields.overdue') }}
          </th>
          <td class="text-right">
            <strong>
              <span v-if="isEnMx">{{
                $t('account.index.pricing.fields.addition')
              }}</span>
              {{ account.plan.overdue_rate | percentSign }}
              {{ $t('account.index.pricing.fields.desc') }}</strong
            >
          </td>
        </tr>
        <tr v-if="!isMx">
          <th class="border-bottom-0">
            {{ $t('account.index.pricing.fields.dbr') }}
          </th>
          <td class="text-right font-weight-bold border-bottom-0">
            {{ currentDbrRate | percentSign }}
          </td>
        </tr>
        <tr v-if="!isMx">
          <td :colspan="2" class="pt-0">
            <div class="d-flex align-center small-text">
              <b-icon-info-circle class="mr-3 small-icon" />
              <p class="mt-1 mb-0">
                {{
                  $t('account.index.pricing.fields.dbrAsOf') +
                  formatDate(account.plan.dbr_details.current.created_at)
                }}
                <b>{{
                  $t('account.index.pricing.fields.dbrPrevRate') +
                  account.plan.dbr_details.previous.dbr +
                  '%)'
                }}</b>
              </p>
            </div>
          </td>
        </tr>
        <tr v-if="!isMx">
          <th>
            {{ $t('account.index.pricing.fields.spreadValue') }}
          </th>
          <td class="text-right small-text font-weight-bold">
            {{ spreadValue | percentSign }}
          </td>
        </tr>
        <tr>
          <th>
            {{ $t('account.index.pricing.fields.interestRate') }}
          </th>
          <td class="text-right">
            <span class="font-weight-bold"
              >{{ account.plan.interest_rate | percentSign }}
              {{ $t('account.index.pricing.fields.pa') }}</span
            >
          </td>
        </tr>
      </table>
    </b-modal>
  </b-card>
</template>

<script>
import moment from 'moment'
import accountsService from '@/services/accounts'

export default {
  props: ['account'],
  data() {
    return {
      showBanner: true,
      currentDbrRate: this.account.plan.dbr_details.current.dbr
    }
  },
  computed: {
    spreadValue() {
      return (this.account.plan.interest_rate - this.currentDbrRate).toFixed(2)
    },
    isMx() {
      return this.$i18n.locale === 'es-MX' || this.$i18n.locale === 'en-MX'
    },
    isEnMx() {
      return this.$i18n.locale === 'en-MX'
    }
  },
  methods: {
    dismissBanner() {
      this.showBanner = false
      return accountsService.pricingBannerInteraction({
        name: 'interest_rate_banner_cta'
      })
    },
    formatDate(str) {
      if (!str) return ''
      return moment(str).format('Do MMMM YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
.pricing-details-widget {
  background-color: $light-blue;
  border: 1px solid $sky-blue;
  border-radius: 8px;
}
.heading {
  display: flex;
  align-items: center;
  font-family: $nunito;
  color: $secondary;
  font-size: 1.33rem;
}
.info-icon {
  color: $secondary;
  width: 2rem;
  height: 2rem;
}
.small-icon {
  color: $secondary;
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.3rem;
}
.close-icon {
  color: $primary;
  width: 1.5rem;
  height: 1.5rem;
  &:hover {
    cursor: pointer;
  }
}
.cross-icon {
  color: $primary;
}
.title-modal {
  font-size: 2.13rem !important;
  color: $secondary !important;
  font-weight: bold;
  border: none;
}
.modal-header {
  border: none;
}
.small-text {
  font-size: 16px;
}
.pricing-banner-link {
  color: $primary;
  text-decoration: none;
  font-weight: 700;
  cursor: pointer;
  margin-left: 56px;
}
.remove-shadow {
  box-shadow: none !important;
}
</style>
